module.exports = __webpack_public_path__ + "img/icon-planner-down.635b5198.svg";